<article class="expansivel alerta" [class.closed]="classClosed" [ngStyle]="{
  'box-shadow': shadow ?  '0 2px 10px rgba(0,0,0,0.2)' : 'none'
}">
    <div
        class="titulo flex-row flex-space-bt content d-flex justify-content-between align-items-center"
        [ngStyle]="{
            'color': mostraAviso ? '#D05100' : 'white', '
            border': mostraAviso ? '1px solid' : {}, 'display': mostraAviso ? 'flex' : {},
            'gap': mostraAviso ? '14px' : {},
            'border-radius': mostraAviso ? '8px' : {},
            'font-size': mostraAviso ? '12px' : {},
            'text-transform': mostraAviso ? 'unset' : {}
        }"
        [style.backgroundColor]="color"
       >
        <img *ngIf="mostraAviso" src="assets/img/icons/icon-atencao.svg" alt="">
        <div class="d-flex flex-column">
          <span [ngStyle]="{ 'color': textColor }">{{ titulo }}
            <img *ngIf="btnConfiguracao" src="assets/img/icons/config-info.svg" (click)="alteraMostraConfRoteiro()"
            alt="" class="ms-2 btn-hover hide-on-mobile"  >
          </span>
        </div>
        <img *ngIf="!btnClose; else close"  (click)="abrirFecharBox()"
            src="assets/img/icons/icon-chevron-down.svg"
            [ngClass]="{'rotated': iconRotated}"
            class="pull-right icon-menu icon" alt=""
        >
        <ng-template #close>
          <img src="assets/img/icons/close-white.svg"  alt="Fechar" (click)="alteraMostraConfRoteiro()">
        </ng-template>

    </div>
    <div
        *ngIf="!mostraAviso"
        class="conteudo"
        [class.ocultar]="classOcultar">
        <div
            class="alerta-info"
            [class.ocultar]="!mensagem">
            <i
                class="fa fa-exclamation-triangle"></i>
                {{ mensagem }}
                <span class='float-right'>{{ horario }}</span>
        </div>
        <ng-content></ng-content>
    </div>
</article>
